module.exports = __webpack_public_path__ + "static/img/app.c309910.svg";


//////////////////
// WEBPACK FOOTER
// ./static/dashboard/app.svg
// module id = sZ2g
// module chunks = 0